import styled from 'styled-components';
import HighchartsReact from 'highcharts-react-official';

export const Chart = styled(HighchartsReact)``;
